import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardArrowLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_arrow_left"}/>
}
